import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import { ACCORDIONS } from "../../pages/wqScorecard/scorecardCopy";

const useStyles = makeStyles((theme) => ({
  details: {
    display: "block",
  },
  paragraph: {
    marginBottom: theme.spacing(1.5),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  summaryTitle: {
    fontWeight: 600,
  },
}));

/**
 * The three explanatory sections, collapsed by default so they never push the
 * table below the fold. Wording lives in scorecardCopy.js.
 */
export default function ScorecardHowToRead() {
  const classes = useStyles();

  return (
    <div>
      {ACCORDIONS.map((section) => (
        <Accordion key={section.id} TransitionProps={{ unmountOnExit: true }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${section.id}-content`}
            id={`${section.id}-header`}
          >
            <Typography className={classes.summaryTitle}>
              {section.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            className={classes.details}
            id={`${section.id}-content`}
          >
            {section.paragraphs.map((paragraph, index) => (
              <Typography
                key={index}
                variant="body2"
                className={classes.paragraph}
              >
                {paragraph}
              </Typography>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
